// extracted by mini-css-extract-plugin
module.exports = {"checkTitleRow":"Canary_checkTitleRow__3HDC-"};